import { FileArrowDown } from '@phosphor-icons/react'
import { pdf } from '@react-pdf/renderer'
import { Modal } from 'antd'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { MeasuresPDF, MeasuresPDFProps } from '@/components/PDF/MeasuresPDF'
import { useCountdown } from '@/hooks/useCountdown'
import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import { useLoadCustomer } from '@/queries/customers/useLoadCustomer'
import { convertHTMLToImage } from '@/utils/convertHTMLToImage'

const TIME_IN_SECONDS = 4

export const PrintMeasuresPDFModal = (
  props: Omit<MeasuresPDFProps, 'chartImage' | 'patient'>
) => {
  const { clientId } = useParams<{ clientId?: string }>()
  const { data: clientInDetail } = useLoadCustomer(clientId || '')
  const updateParams = useUpdateURLSearchParams()

  const printPDF = async () => {
    const chartImage = await convertHTMLToImage(
      'measures-chart-container',
      'png'
    )
    const blob = await pdf(
      <MeasuresPDF
        {...props}
        {...{
          chartImage,
          patient: {
            firstName: clientInDetail?.first_name || '',
            lastName: clientInDetail?.last_name || '',
            birthdate: clientInDetail?.date_birth || '',
          },
        }}
      />
    )?.toBlob()
    const objectURL = window.URL.createObjectURL(blob)
    window.open(objectURL, '_blank')
    updateParams(['print', undefined])
  }

  const { seconds, resume } = useCountdown({
    initialSeconds: TIME_IN_SECONDS,
    onComplete: printPDF,
  })

  const progress = ((TIME_IN_SECONDS - seconds) / TIME_IN_SECONDS) * 100

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => resume(), [])
  return (
    <Modal
      open
      closeIcon={false}
      footer={() => undefined}
      styles={{
        mask: { backgroundColor: 'rgba(0,0,0,0.7)' },
      }}
      title="Generate Measures PDF"
    >
      <div className="mt-8 flex w-full flex-col items-center justify-center gap-3">
        <div className="relative flex h-24 w-24 items-center justify-center rounded-full border-[3px] border-solid border-gray-300 bg-gray-100">
          <FileArrowDown className="text-4xl text-primary" />
          <div className="sparkle-1 absolute h-2 w-2 rounded-full bg-blue-400"></div>
          <div className="sparkle-2 absolute h-2 w-2 rounded-full bg-purple-400"></div>
          <div className="sparkle-3 absolute h-3 w-3 rounded-full bg-pink-400"></div>
        </div>
        <p className="w-full text-center text-gray-600">
          Just a moment while we generate your PDF
        </p>
        <p className="w-full text-center text-xl font-bold text-primary">
          {seconds} seconds remaining
        </p>
        <div className="mt-4 h-1.5 w-full rounded-full bg-gray-200">
          <div
            className="h-1.5 rounded-full bg-gradient-to-r from-blue-200 to-primary transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </Modal>
  )
}
